import { PageLayout } from "@/components/PageLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function Terms() {
  return (
    <PageLayout>
      <Card className="max-w-4xl mx-auto">
        <CardHeader>
          <CardTitle className="text-3xl">Terms & Conditions</CardTitle>
          <p className="text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
        </CardHeader>
        <CardContent className="prose prose-sm dark:prose-invert max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing and using CalcLab, you accept and agree to be bound by the terms and provision of this agreement. 
              If you do not agree to these terms, please do not use our service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">2. Service Description</h2>
            <p>
              CalcLab provides scientific calculators and tools for physics, chemistry, finance, and mathematics. We offer both free and paid services:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Free Access:</strong> All standard calculators and tools, favorites feature, and 1 free SuperCalc query</li>
              <li><strong>Student & Educator Membership ($44/year):</strong> Unlimited SuperCalc AI solver access, lesson plan generator for math/science topics + all free features</li>
              <li><strong>Paid Membership ($88/year):</strong> Unlimited SuperCalc + priority support + all features</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">3. SuperCalc Pricing Transparency</h2>
            <p>
              SuperCalc is a paid feature because it uses advanced AI models that incur real costs for each query. 
              We charge only to cover operational expenses and maintain service quality—this is not a profit maximization strategy. 
              Our pricing is designed to be fair and sustainable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">4. Free Trial</h2>
            <p>
              All registered users receive 1 free SuperCalc query to test the service before committing to a paid subscription. 
              This trial is provided once per account and cannot be reset or transferred.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">5. Refund Policy</h2>
            <p>
              We offer a 7-day money-back guarantee on all paid subscriptions with the following conditions:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Refund requests must be submitted within 7 days of purchase</li>
              <li>The refund amount will be the full subscription price minus the actual cost of any SuperCalc queries used during the period</li>
              <li>SuperCalc usage costs will be calculated based on our operational costs (AI model tokens consumed)</li>
              <li>Refunds are processed to the original payment method within 5-10 business days</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">6. User Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account and password. 
              You agree to accept responsibility for all activities that occur under your account.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">7. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Use the service for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to any portion of the service</li>
              <li>Abuse, harass, or harm other users</li>
              <li>Share your account credentials with others</li>
              <li>Use automated systems to access the service without permission</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">8. Intellectual Property</h2>
            <p>
              All content, features, and functionality of CalcLab are owned by us and are protected by international 
              copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">9. Limitation of Liability</h2>
            <p>
              CalcLab is provided "as is" without warranties of any kind. We shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages resulting from your use or inability to use the service. 
              The calculations and solutions provided are for educational purposes only and should be verified independently 
              for critical applications.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">10. Termination</h2>
            <p>
              We reserve the right to terminate or suspend your account at our sole discretion, without notice, 
              for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">11. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of any material changes 
              via email or through the service. Continued use after changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">12. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with applicable laws, 
              without regard to its conflict of law provisions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">13. Contact</h2>
            <p>
              For questions about these Terms, please contact us through our support page (available to paid members).
            </p>
          </section>
        </CardContent>
      </Card>
    </PageLayout>
  );
}
